module.exports = __webpack_public_path__ + "img/dot-gray.f205a800.svg";